// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProductTcService = {};

ProductTcService.postProductTc = function (data) {
  return lossClient({
    url: `/producttc/add`,
    method: "post",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductTCs: data.ProductTCs,
      userid: "Santani",
    },
  });
};

ProductTcService.getProductTcList = function (data) {
  return lossClient({
    url: "/producttype",
    method: "get",
    data: data,
  });
};

ProductTcService.getProductTcDetail = function (data) {
  return lossClient({
    url: `/producttype/${data}`,
    method: "get",
  });
};

ProductTcService.updateProductTc = function (data) {
  return lossClient({
    url: `/producttc/edit`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductTCs: data.ProductTCs,
      userid: "Santani",
    },
  });
};

ProductTcService.deleteProductTc = function (data) {
  return lossClient({
    url: `/producttc/delete`,
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductTCs: data.ProductTCs,
      userid: "Santani",
    },
  });
};
ProductTcService.returnProductTc = function (data) {
  return lossClient({
    url: `/producttc/return`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductTCs: data.ProductTCs,
      userid: "Santani",
    },
  });
};
ProductTcService.approveProductTc = function (data) {
  return lossClient({
    url: `/producttc/approve`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductTCs: data.ProductTCs,
      userid: "Santani",
    },
  });
};
ProductTcService.requestProductTc = function (data) {
  return lossClient({
    url: `/producttc/request`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductTCs: data.ProductTCs,
      Request: data.Request,
      Note: data.Note,
      userid: "Santani",
    },
  });
};
ProductTcService.rejectProductTc = function (data) {
  return lossClient({
    url: `/producttc/reject`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      ProductTCs: data.ProductTCs,
      userid: "Santani",
    },
  });
};

export default ProductTcService;
